/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ICustomerReportSetting,
  ISearchCustomerReportSettingReq,
  ISearchCustomerReportSettingRes,
} from '../interfaces/customerRerportSetting';
import * as baseAdapter from './baseAdapter';

export const searchCutomerReportSettings = async (
  req: ISearchCustomerReportSettingReq,
) => {
  const ret = await baseAdapter.post<ISearchCustomerReportSettingRes>(
    '/customerReportSetting/gets',
    req,
  );
  return ret;
};

export const addCutomerReportSetting = async (
  data: Partial<ICustomerReportSetting>,
) => {
  const ret = await baseAdapter.post('/customerReportSetting/create', data);
  return ret;
};

export const editCutomerReportSetting = async (
  data: Partial<ICustomerReportSetting>,
) => {
  const ret = await baseAdapter.put(
    `/customerReportSetting/update/${data.id}`,
    data,
  );
  return ret;
};

export const deleteCutomerReportSetting = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(
    `/customerReportSetting/delete/${id}`,
  );
  return ret;
};
